import { atom } from 'jotai';
import { AppToolId, BuildInAppToolId } from '../types/appTools';

export const SelectedAppToolAtom = atom<AppToolId>(BuildInAppToolId.Messages);

type EnabledAppTool = Record<AppToolId, boolean>;

export const EnabledAppToolsForSessionAtom = atom<EnabledAppTool>({});
export const IsExpandedAppTool = atom<boolean>(false);
